import React from "react";

function Warning() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      fill="none"
      viewBox="0 0 40 40"
    >
      <path
        stroke="var(--color-neutral-dark-darker)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.5"
        d="M36.217 30L22.884 6.667a3.333 3.333 0 00-5.8 0L3.75 30a3.333 3.333 0 002.917 5h26.667a3.334 3.334 0 002.883-5zM20 15v6.667M20 28.333h.017"
      ></path>
    </svg>
  );
}

export default Warning;
